import React from 'react';
import styled from 'styled-components';
import { device } from "../device";

const Block = styled.div`
    margin-bottom: 48px;
    @media ${device.lg} {
        margin-bottom: 64px;
    }
`;

const DescriptionBlock = ({ children }) => {
    return (
        <Block>{children}</Block>
    );
};

export default DescriptionBlock;
